import { TextWrapper } from './styled';
import { Text } from '@simplywallst/ui-core';

export const FairValueTooltip = () => (
  <TextWrapper rowGap="8px">
    <Text typography="tiny" color="spaceGray">
      Fair value is the current intrinsic value of a company based on an
      estimate of its potential future profits (analyst consensus forecasts).
    </Text>
    <Text typography="tiny" color="spaceGray">
      The discount is the difference between the current price and its estimated
      fair value.
    </Text>
    <Text typography="tiny" color="spaceGray">
      Learn more about valuation on our Help Centre
    </Text>
  </TextWrapper>
);
